import { custom, enum as zenum } from 'zod';

const TIME_RANGE_OPTIONS = ['LAST_HOUR', 'LAST_6_HOURS', 'LAST_24_HOURS', 'CUSTOM_RANGE'] as const;
export const TimeRangeEnum = zenum(TIME_RANGE_OPTIONS);

// TODO: discuss with  the team if we want to keep this approach or use date objects
export type DateTimeForFilterTemplate = `${number}-${number}-${number}-${number}-${number}`;
export const DateTimeForFilterSchema = custom<DateTimeForFilterTemplate>((val) => {
  return typeof val === 'string'
    ? /^(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])-\d{4}-(0[0-9]|1[0-9]|2[0-3])-[0-5][0-9]$/.test(
        val,
      )
    : false;
});
